const INTEGRATED_ACCOUNT_EXPLORER_TYPES = new Set(['truto', 'cardamom'])
const CATALOG_CONNECTOR_TYPES = new Set<string>()
const CARDAMOM_FAMILY_TYPES = new Set(['cardamom'])

export type ExplorerTypeMeta = {
  type: string
  integrated_account_explorer?: boolean
  catalog?: boolean
}

/** Call after fetching GET /connectors/types so dynamic catalog types are recognized. */
export function registerExplorerTypesFromTypeInfo(types: ExplorerTypeMeta[]): void {
  for (const t of types) {
    const type = t.type.toLowerCase()
    if (t.integrated_account_explorer || t.catalog) {
      INTEGRATED_ACCOUNT_EXPLORER_TYPES.add(type)
    }
    if (t.catalog || type === 'cardamom') {
      CARDAMOM_FAMILY_TYPES.add(type)
      if (t.catalog) CATALOG_CONNECTOR_TYPES.add(type)
    }
  }
}

export function isIntegratedAccountExplorerType(type: string): boolean {
  return INTEGRATED_ACCOUNT_EXPLORER_TYPES.has(type.toLowerCase())
}

export function isCatalogConnectorType(type: string): boolean {
  return CATALOG_CONNECTOR_TYPES.has(type.toLowerCase())
}

export function isCardamomFamilyType(type: string): boolean {
  return CARDAMOM_FAMILY_TYPES.has(type.toLowerCase())
}

/** Read the pinned integrated_account_id from a connector's config (if any). */
export function connectorPinnedAccountId(conn: {
  config: string | Record<string, unknown>
}): string | null {
  const cfg = typeof conn.config === 'string'
    ? (() => { try { return JSON.parse(conn.config) as Record<string, unknown> } catch { return {} } })()
    : (conn.config ?? {})
  const id = cfg.integrated_account_id
  return typeof id === 'string' && id.trim() ? id.trim() : null
}
